import { Autocomplete, TextField, Chip } from "@mui/material";

const MultiSelectAutocomplete = ({
  id = "multi-select-autocomplete",
  placeholder = "Select items",
  options = [],
  value = [],
  labelKey = "username",
  disabled = false,
  onChange = () => { },
  size = "medium",
  ...rest
}) => {
  return (
    <Autocomplete
      multiple
      id={id}
      size={size}
      options={options}
      getOptionLabel={(option) => option[labelKey] || ""}
      value={value}
      onChange={onChange}
      disabled={disabled}
      filterSelectedOptions
      {...rest}
      renderTags={(selected, getTagProps) =>
        selected.map((option, index) => (
          <Chip
            size={size}
            key={option.id || option[labelKey]}
            label={option[labelKey]}
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          size={size}
          placeholder={placeholder}
          sx={{
            "& .MuiInputBase-root": {
              minHeight: size === "small" ? "32px" : "40px",
              paddingTop: size === "small" ? "2px !important" : "inherit",
              paddingBottom: size === "small" ? "2px !important" : "inherit",
            },
            "& .MuiOutlinedInput-root": {
              padding: size === "small" ? "2px 8px !important" : "inherit",
            },
          }}
        />
      )}
    />
  );
};

export default MultiSelectAutocomplete;
